import { cryptoInstance } from '@/public/fetch/index';
import { ssApi2 } from '@/public/utils/basePath';
const baseURL = ssApi2;
// 获取讲师课程
export const getExpertCourse = (data) => {
    return cryptoInstance.post(`/course/search/by/expert`, data, { baseURL });
};
// 获取讲师信息
export const getExpertInfo = (params) => {
    return cryptoInstance.get(`/expert/search`, { baseURL, params });
};
// 搜索反馈
export const searchFeedBack = (data) => {
    return cryptoInstance.post(`/feedback/add`, data, { baseURL });
};
